import { ActionIcon, TextInput, type TextInputProps } from '@mantine/core';
import { IconSearch, IconX } from '@tabler/icons-react';

export type SearchInputProps = Omit<TextInputProps, 'leftSection'> & {
  /** Icon size for the search icon. @default 16 */
  iconSize?: number;
};

/**
 * TextInput pre-configured with a search icon and a clear (×) button.
 * Drop-in replacement for any `<TextInput leftSection={<IconSearch />} />` pattern.
 */
export function SearchInput({ iconSize = 16, value, onChange, ...rest }: SearchInputProps): JSX.Element {
  const hasValue = typeof value === 'string' ? value.length > 0 : !!value;

  return (
    <TextInput
      leftSection={<IconSearch size={iconSize} />}
      rightSection={
        hasValue ? (
          <ActionIcon
            size="xs"
            variant="subtle"
            color="gray"
            onClick={() => {
              if (onChange) {
                const syntheticEvent = { currentTarget: { value: '' }, target: { value: '' } } as React.ChangeEvent<HTMLInputElement>;
                onChange(syntheticEvent);
              }
            }}
            aria-label="Clear search"
          >
            <IconX size={14} />
          </ActionIcon>
        ) : null
      }
      value={value}
      onChange={onChange}
      {...rest}
    />
  );
}
